import { render, staticRenderFns } from "./CFormFieldset.vue?vue&type=template&id=513386e9&scoped=true&"
import script from "./CFormFieldset.vue?vue&type=script&lang=js&"
export * from "./CFormFieldset.vue?vue&type=script&lang=js&"
import style0 from "./CFormFieldset.vue?vue&type=style&index=0&id=513386e9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513386e9",
  null
  
)

export default component.exports